// The client every Careline view runs: the MCP Apps view protocol (2026-01-26) as raw JSON-RPC over postMessage, so a
// view is one self-contained document with no library to fetch (own-app views FR-4: its CSP admits no app-origin
// assets). It talks to its parent only; the host decides what a `tools/call` may reach (FR-10), so nothing here is a
// permission. Authored as a string because it is inlined into each view's HTML.
export const viewRuntime = `
var view = (function () {
  var nextId = 1, pending = {}, resultHandler = null, lastResult = null, initialized = false;
  function send(message) { window.parent.postMessage(message, "*"); }
  function request(method, params) {
    var id = nextId++;
    send({ jsonrpc: "2.0", id: id, method: method, params: params });
    return new Promise(function (resolve) { pending[id] = resolve; });
  }
  function notify(method, params) { send({ jsonrpc: "2.0", method: method, params: params }); }
  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function requestId() { return "view-" + (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random()); }
  function structured(result) {
    return result && result.structuredContent && result.structuredContent.data ? result.structuredContent.data : null;
  }
  /** An app error is "<stable_code>: <message> (...)" in text content; a protocol error carries its own code. */
  function failure(reply) {
    if (reply.error) return { ok: false, code: String(reply.error.code), message: reply.error.message || "The host refused the call." };
    var content = (reply.result && reply.result.content) || [];
    var text = content.length && content[0].text ? content[0].text : "The call failed.";
    var match = /^([a-z_]+): ([\\s\\S]*)$/.exec(text);
    return { ok: false, code: match ? match[1] : "error", message: match ? match[2] : text };
  }
  /** Call one of the app's own tools through the host. Resolves to { ok: true, data } or { ok: false, code, message }. */
  function callTool(name, args) {
    return request("tools/call", { name: name, arguments: args }).then(function (reply) {
      if (reply.error || !reply.result || reply.result.isError) return failure(reply);
      return { ok: true, data: structured(reply.result) };
    });
  }
  function reportSize() {
    if (!initialized) return;
    notify("ui/notifications/size-changed", { height: Math.ceil(document.documentElement.getBoundingClientRect().height) });
  }
  window.addEventListener("message", function (event) {
    if (event.source !== window.parent) return;
    var m = event.data || {};
    if (m.id !== undefined && !m.method && pending[m.id]) { pending[m.id](m); delete pending[m.id]; return; }
    if (m.method === "ui/notifications/tool-result") {
      lastResult = m.params;
      if (resultHandler) resultHandler(structured(m.params), m.params);
    } else if (m.method === "ui/resource-teardown" || m.method === "ping") {
      if (m.id !== undefined) send({ jsonrpc: "2.0", id: m.id, result: {} });
    }
  });
  request("ui/initialize", {
    protocolVersion: "2026-01-26",
    appInfo: { name: "careline-view", version: "1" },
    appCapabilities: {}
  }).then(function (reply) {
    if (reply.error) { document.body.textContent = "The host refused this view."; return; }
    initialized = true;
    notify("ui/notifications/initialized", {});
    if (window.ResizeObserver) new ResizeObserver(reportSize).observe(document.body);
    reportSize();
  });
  return {
    esc: esc,
    requestId: requestId,
    callTool: callTool,
    reportSize: reportSize,
    /** Run fn for every tool result the host delivers (the host sends it once the view is initialized). */
    onResult: function (fn) { resultHandler = fn; if (lastResult) fn(structured(lastResult), lastResult); }
  };
})();
`;
